export const DEBT = {
  isHidden: true,
  nickname: 'PRODUCTS.DEBT.nickname',
  icon:'debt'
};
